import { createRouter, createWebHistory } from 'vue-router'
import InventoryOverview from '@/components/InventoryOverview.vue'
import FeedSources from '@/components/FeedSources.vue'
import InventorySegmentation from '@/views/InventorySegmentation.vue'
import VehicleFieldMapping from '@/views/VehicleFieldMapping.vue'
import VehicleListingSettings from '@/views/VehicleListingSettings.vue'
import VehicleFieldValuesPreview from '@/views/VehicleFieldValuesPreview.vue'
import VehicleLookup from '@/views/VehicleLookup.vue'
import UnpublishedChanges from '@/views/UnpublishedChanges.vue'
import Inventory from '@/views/Inventory.vue'
import ArchivedInventory from '@/views/ArchivedInventory.vue'
import AddVehicle from '@/views/AddVehicle.vue'
import AddVehicleAi from '@/views/AddVehicleAi.vue'
import EditVehicle from '@/views/EditVehicle.vue'
import VehicleDetails from '@/views/VehicleDetails.vue'
import DebugDashboard from '@/views/DebugDashboard.vue'
import Settings from '@/views/Settings.vue'
import FeedSourceConfiguration from '@/views/FeedSourceConfiguration.vue'
import GroupSiteConfig from '@/views/GroupSiteConfig.vue'
import Observability from '@/views/Observability.vue'
import FeedConditionRules from '@/views/FeedConditionRules.vue'
import AccountConfiguration from '@/views/AccountConfiguration.vue'
import PublishFlow from '@/views/PublishFlow.vue'
import PublishPreview from '@/views/PublishPreview.vue'
import Setup from '@/views/Setup.vue'
import { PUBLISH_PREVIEW_ENABLED } from '@/constants/publishPreviewVisibility'

const routes = [
  { path: '/', name: 'InventoryOverview', component: InventoryOverview },
  { path: '/setup', name: 'Setup', component: Setup },
  { path: '/feeds', name: 'FeedSources', component: FeedSources },
  { path: '/segments', name: 'SegmentList', component: InventorySegmentation },
  { path: '/mapping', name: 'FieldMapping', component: VehicleFieldMapping },
  { path: '/listing', name: 'ListingRules', component: VehicleListingSettings },
  { path: '/vehicle-lookup', name: 'VehicleLookup', component: VehicleLookup },
  { path: '/vin', name: 'VinAnalysis', component: VehicleFieldValuesPreview },
  { path: '/unpublished', name: 'UnpublishedChanges', component: UnpublishedChanges },
  { path: '/inventory', name: 'Inventory', component: Inventory },
  { path: '/inventory/archived', name: 'ArchivedInventory', component: ArchivedInventory },
  { path: '/inventory/add', name: 'AddVehicle', component: AddVehicle },
  { path: '/inventory/add-ai', name: 'AddVehicleAi', component: AddVehicleAi },
  { path: '/inventory/:vin/edit', name: 'EditVehicle', component: EditVehicle },
  { path: '/inventory/:vin', name: 'VehicleDetails', component: VehicleDetails },
  { path: '/debug', name: 'DebugDashboard', component: DebugDashboard },
  { path: '/settings', name: 'Settings', component: Settings },
  {
    path: '/feed-source-configuration',
    name: 'FeedSourceConfiguration',
    component: FeedSourceConfiguration,
  },
  { path: '/group-site', name: 'GroupSiteConfig', component: GroupSiteConfig },
  {
    path: '/observability',
    alias: '/inventory-flow',
    name: 'InventoryFlow',
    component: Observability,
  },
  { path: '/feed-condition-rules', name: 'FeedConditionRules', component: FeedConditionRules },
  {
    path: '/account-configuration',
    name: 'AccountConfiguration',
    component: AccountConfiguration,
  },
  {
    path: '/observability/publish/:correlationId',
    name: 'PublishFlow',
    component: PublishFlow,
  },
  {
    path: '/publish-preview',
    name: 'PublishPreview',
    component: PublishPreview,
    beforeEnter: () => {
      // TEMPORARY:
      // Block user access while Publish Preview prediction accuracy is being worked on.
      // Keep the route/page implementation intact for later re-enablement.
      if (!PUBLISH_PREVIEW_ENABLED) {
        return { path: '/unpublished' }
      }
    },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
